'use client';
import { Stepper, Step, StepLabel, StepContent } from '@mui/material';
import { styled } from '@mui/material/styles';

export const BaseStepper = styled(Stepper)();
export const BaseStep = styled(Step)();
export const BaseStepLabel = styled(StepLabel)();
export const BaseStepContent = styled(StepContent)();
